import React, { useState, useEffect } from "react";
import Head from "next/head";
import Image from "next/image";
import { useRouter } from "next/router";
import useDeviceSize from "../../utils/useDeviceSize";
import { BASE_ASSETS_URL } from "../../constants/constants";
import { IntercomProvider, useIntercom } from "react-use-intercom";

const INTERCOM_APP_ID = "jldyfmwj";

const SupportSec = ({ refId }) => {
  let router = useRouter();
  let pathname = router.pathname;
  let [width] = useDeviceSize();

  return (
    <div
      id={refId}
      className="py-12 flex flex-col justify-center items-center px-4 xxl:-mx-12"
    >
      <div className="h-10 mb-4">
        <Image
          className="h-full"
          width={220}
          height={10}
          src={`${BASE_ASSETS_URL}/support/stars.png`}
          alt=""
          loading="lazy"
        />
      </div>
      <h3 className="text-center text-3xl sm:text-5xl font-bold mb-4">
        Award-winning support<span className="text-[#9C6CFF]">.</span>
      </h3>
      <p className="text-center text-base sm:text-xl">
        Best-in-class support. We’re always here to help – here’s how to
        connect.
      </p>
      <div className="flex flex-row mt-12 flex-wrap lg:flex-nowrap">
        <SupportCard
          image={`${BASE_ASSETS_URL}/support/live-chat-support.png`}
          title="Chat with Us"
          description="Ask a question right now."
          buttonText="Start a chat"
          buttonLink="https://wa.me/message/MBQ5HUL53GQVK1"
        />
        <SupportCard
          image={`${BASE_ASSETS_URL}/support/support-email.png`}
          title="Email"
          description="Get in touch by email."
          buttonText="Send an Email"
          marginRight={width > 1024 ? "sm:mr-6" : "mr-0"}
          buttonLink={"mailto:support@boloforms.com"}
        />
        <SupportCard
          image={`${BASE_ASSETS_URL}/support/helpcenter.png`}
          title="Help center"
          description="In Depth Guides."
          buttonText="Read articles"
          buttonLink={
            pathname?.includes("/timer-classroom")
              ? "http://timer-docs.boloforms.com/"
              : "http://approval-docs.boloforms.com/"
          }
        />
        <SupportCard
          image={`${BASE_ASSETS_URL}/support/book-time.png`}
          title="Google Meet"
          description="Guided support and Q&A."
          buttonText="Book a time"
          marginRight="mr-0"
          buttonLink="https://calendly.com/boloforms/15min"
        />
      </div>
    </div>
  );
};

export default SupportSec;

const SupportCard = ({
  image,
  title = "Live Chat",
  description = "Chat with us live 24/7",
  buttonText = "Chat with us",
  buttonLink = "#",
  marginRight = "sm:mr-6",
}) => {
  const openLink = () => {
    if (title === "Chat with Us") {
      show();
    } else {
      window.open(buttonLink, "_self");
    }
  };

  return (
    <div
      style={{
        boxShadow:
          "rgb(0 0 0 / 4%) 0 1px 0, rgb(0 0 0 / 5%) 0 2px 7px, rgb(0 0 0 / 6%) 0 12px 22px",
      }}
      className={`w-full bg-white sm:w-[47%] lg:w-full p-8 ${marginRight} mb-6 rounded-xl flex flex-col justify-between`}
    >
      <div>
        <div className="mb-4">
          <Image
            src={image}
            className="w-auto h-auto"
            width={10}
            height={10}
            alt="support"
            loading="lazy"
          />
        </div>
        <h2 className="text-2xl font-bold mb-2">? {title}</h2>
        <p className="mb-2">{description}</p>
      </div>
      {title === "Chat with Us" ? (
        <IntercomProvider appId={INTERCOM_APP_ID}>
          <InterCom />
        </IntercomProvider>
      ) : (
        <button
          onClick={() => window.open(buttonLink, "_blank")}
          className="w-full text-sm font-medium border-2 border-[#9C6CFF] hover:bg-[#9C6CFF] hover:text-white py-1.5 rounded-lg mt-6"
        >
          {buttonText}
        </button>
      )}
    </div>
  );
};

const InterCom = () => {
  const { boot, show } = useIntercom();

  useEffect(() => {
    boot();
  }, []);

  return (
    <>
      <button
        onClick={show}
        className="w-full text-sm font-medium border-2 border-[#9C6CFF] hover:bg-[#9C6CFF] hover:text-white py-1.5 rounded-lg mt-6"
      >
        Start a Chat
      </button>
    </>
  );
};
